import { Select } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
const { Option } = Select;

const FilterSelect = ({ 
    label, 
    value, 
    onChange, 
    options, 
    placeholder, 
    loading = false,
    minWidth = '55px',
    selectWidth = '180px',
    customStyles = {},
    selectCustomStyles = {}
  }) => (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center',
      gap: '8px',
      ...customStyles
    }}>
      <Select
        value={value}
        onChange={onChange}
        style={{ width: selectWidth, ...selectCustomStyles }}
        size="small"
        allowClear={{
          clearIcon: <CloseCircleOutlined style={{ color: '#ef4444' }} />
        }}
        showSearch
        placeholder={placeholder}
        loading={loading}
        dropdownStyle={{ maxHeight: 300, overflow: 'auto' }}
        filterOption={(input, option) =>
          (option?.children || "").toLowerCase().includes(input.toLowerCase())
        }
      >
        {options.map((option) => (
          <Option key={option.value || option} value={option.value || option}>
            {option.label || option}
          </Option>
        ))}
      </Select>
    </div>
  );
  

export default FilterSelect;